// extracted by mini-css-extract-plugin
module.exports = {"support":"Support_support__3W7lh","centered":"Support_centered__S9K2N"};